import { environment } from '../../../environments';

import { useGetWidgetName } from './useGetWidgetName';
import { useGetWhitelabelName } from './useGetWhitelabelName';
import { useGetSearchParams } from './useGetSearchParams';
import { getWidgetNameInSnakeCase, convertSearchParamsForTracking } from '../../../utils/tracker';
import { WidgetName } from '../../../models';

type TrackerParams = {
  isTrackingEnabled: boolean;
  widgetName?: string;
  partnerName: string;
  searchParams?: any;
};

export const useGetTrackerParams = (
  widgetNameParam?: WidgetName,
  whitelabelNameParam?: string
): TrackerParams => {
  const whitelabelName = useGetWhitelabelName();
  const partnerName =
    !whitelabelName || whitelabelName === '' ? whitelabelNameParam || '' : whitelabelName;

  const searchParams = useGetSearchParams();
  const trackerSearchParams = convertSearchParamsForTracking(searchParams);

  const widgetName = useGetWidgetName() || widgetNameParam;
  const widgetNameForTracking =
    widgetName && searchParams
      ? getWidgetNameInSnakeCase(widgetName, searchParams.search_type)
      : undefined;

  const isTrackingEnabled = widgetNameForTracking && environment.production;

  return {
    isTrackingEnabled: !!isTrackingEnabled,
    widgetName: widgetNameForTracking,
    partnerName,
    searchParams: trackerSearchParams,
  };
};
